import React, { Fragment } from 'react';

import { BmwFront } from '../../../../images/UberTorontoLinks';
import { bmwSideViewLeft } from '../../../../images/landingLinks';

import Heading from '../Shared/Heading';
import WhyDrive from '../Shared/WhyDrive';
import BmwTop from '../../UberToronto/BmwTop';
import FleetFaq from '../Shared/FleetFaq';
import WhyWait from '../Shared/WhyWait';
import TorontoFooter from '../../../Layout/TorontoFooter';
import cardPro from './CardContentPro';
import faqPro from './FaqContentPro';

import { faAngleDoubleUp } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import ScrollLock from 'react-scrolllock';

const ProContainer = () => (
  <Fragment>
    <ScrollLock>
      <div className="landing__scroll">
        <Heading
          header="Autzu PRO"
          price="$6"
          notes={['Higher ratings', 'Premium cars', 'More earnings']}
          image={BmwFront}
          icon={
            <FontAwesomeIcon icon={faAngleDoubleUp} fixedWidth size="2x" />
          }
        />
        <WhyDrive
          header="Why Autzu PRO?"
          cards={cardPro}
          topView={<BmwTop pro={true} landing={false} />}
          pro
        />
        <FleetFaq faqContent={faqPro} />
        <WhyWait carImage={bmwSideViewLeft} />
        <TorontoFooter />
      </div>
    </ScrollLock>
  </Fragment>
);

export default ProContainer;



// WEBPACK FOOTER //
// ./src/components/Static/TorontoFleets/AutzuPro/ProContainer.js